import {
  FETCH_EXPERT_PROFILE_REQUEST,
  FETCH_EXPERT_PROFILE_SUCCESS,
  FETCH_EXPERT_PROFILE_FAIL,
  UPSERT_EXPERT_PROFILE_REQUEST,
  UPSERT_EXPERT_PROFILE_SUCCESS,
  UPSERT_EXPERT_PROFILE_FAIL,
  SUBMIT_EXPERT_PROFILE_FOR_REVIEW_REQUEST,
  SUBMIT_EXPERT_PROFILE_FOR_REVIEW_SUCCESS,
  SUBMIT_EXPERT_PROFILE_FOR_REVIEW_FAIL,
  FETCH_EXPERT_PROFILE_BY_USER_ID_REQUEST,
  FETCH_EXPERT_PROFILE_BY_USER_ID_SUCCESS,
  FETCH_EXPERT_PROFILE_BY_USER_ID_FAIL,
  FETCH_EXPERT_LIST_REQUEST,
  FETCH_EXPERT_LIST_SUCCESS,
  FETCH_EXPERT_LIST_FAIL,
  RESET_EXPERT_PROFILE_ERROR,
} from "./expertProfileTypes";

const initialState = {
  myProfile: null,
  viewedExpertProfile: null,
  expertsList: [],
  loadingMyProfile: false,
  loadingUpsert: false,
  loadingSubmitForReview: false,
  loadingView: false,
  loadingList: false,
  error: null,
};

export const expertProfileReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_EXPERT_PROFILE_REQUEST:
      return {
        ...state,
        loadingMyProfile: true,
        error: null,
      };
    case FETCH_EXPERT_PROFILE_SUCCESS:
      return {
        ...state,
        loadingMyProfile: false,
        myProfile: action.payload,
      };
    case FETCH_EXPERT_PROFILE_FAIL:
      return {
        ...state,
        loadingMyProfile: false,
        error: action.payload,
      };

    case UPSERT_EXPERT_PROFILE_REQUEST:
      return {
        ...state,
        loadingUpsert: true,
        error: null,
      };
    case UPSERT_EXPERT_PROFILE_SUCCESS:
      return {
        ...state,
        loadingUpsert: false,
        myProfile: action.payload,
      };
    case UPSERT_EXPERT_PROFILE_FAIL:
      return {
        ...state,
        loadingUpsert: false,
        error: action.payload,
      };

    case SUBMIT_EXPERT_PROFILE_FOR_REVIEW_REQUEST:
      return {
        ...state,
        loadingSubmitForReview: true,
        error: null,
      };
    case SUBMIT_EXPERT_PROFILE_FOR_REVIEW_SUCCESS:
      return {
        ...state,
        loadingSubmitForReview: false,
      };
    case SUBMIT_EXPERT_PROFILE_FOR_REVIEW_FAIL:
      return {
        ...state,
        loadingSubmitForReview: false,
        error: action.payload,
      };

    case FETCH_EXPERT_PROFILE_BY_USER_ID_REQUEST:
      return {
        ...state,
        loadingView: true,
        error: null,
      };
    case FETCH_EXPERT_PROFILE_BY_USER_ID_SUCCESS:
      return {
        ...state,
        loadingView: false,
        viewedExpertProfile: action.payload,
      };
    case FETCH_EXPERT_PROFILE_BY_USER_ID_FAIL:
      return {
        ...state,
        loadingView: false,
        error: action.payload,
      };

    case FETCH_EXPERT_LIST_REQUEST:
      return {
        ...state,
        loadingList: true,
        error: null,
      };
    case FETCH_EXPERT_LIST_SUCCESS:
      return {
        ...state,
        loadingList: false,
        expertsList: Array.isArray(action.payload) ? action.payload : [],
      };
    case FETCH_EXPERT_LIST_FAIL:
      return {
        ...state,
        loadingList: false,
        error: action.payload,
      };

    case RESET_EXPERT_PROFILE_ERROR:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};
